import { Routes } from '@angular/router';

import { UploadFile } from './upload-file/upload-file';
import { RedactionTest } from './redaction-test/redaction-test';
import { RedactTheFact } from './redact-the-fact/redact-the-fact';

export const routes: Routes = [
  { path: 'upload', component: UploadFile },
  { path: 'redaction', component: RedactionTest },
  { path: 'redactthefact/:userId/:documentId', component: RedactTheFact }
];
